import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import {
  STOCK_STATUS_AVAILABLE,
  STOCK_STATUS_NOT_AVAILABLE,
  StockType,
} from 'types/ProductPageV2/ProductsStocks';

import styles from './ProductUniqSize.module.scss';

function ProductUniqSize({ stock }: { stock: StockType }): JSX.Element {
  const { t } = useTranslation(['productPage', 'translation']);
  const { state, stateLabel } = stock;

  /**
   * Add available state class
   *
   * @param {number} state
   */
  const addAvailableStateClass = (state: number) => {
    return {
      [styles.available]: state === STOCK_STATUS_AVAILABLE,
      [styles.notAvailable]: state === STOCK_STATUS_NOT_AVAILABLE,
    };
  };

  return (
    <>
      <div className={styles.container}>
        <span className={styles.title}>
          {`${t('LABEL_SIZE', { ns: 'translation' })} :`}
        </span>
        <span className={styles.label}>{t('LABEL_UNIQ_SIZE')}</span>
        <span
          className={classnames(styles.state, addAvailableStateClass(state))}
        >
          {stateLabel}
        </span>
      </div>
    </>
  );
}

export default ProductUniqSize;
